/**
 * Материал занятий темпа.
 *
 * Оба режима работают на частотных словах: разгоняться и добиваться чистоты
 * нужно на том, что человек действительно печатает, а не на выдуманных
 * последовательностях (ТЗ §6, правило под таблицей режимов).
 *
 * Слова различаются длиной: скорость набирается на коротких частотных
 * словах, где темп упирается в моторику, а чистота — на словах подлиннее, где
 * ошибиться есть где.
 */

import type { LanguageCode } from '@type2x/shared-contracts';
import { getWords } from '@type2x/corpora';

import type { TempoMode } from '../contracts/tempo.js';

/** Сколько слов берётся в пул режима. */
const POOL_SIZE = 60;

/** Длины слов, на которых тренируется режим. */
const LENGTHS: Readonly<Record<TempoMode, { minLength: number; maxLength: number }>> = {
  speed: { minLength: 2, maxLength: 6 },
  accuracy: { minLength: 5, maxLength: 12 },
};

/** Пул слов режима в порядке убывания частоты. */
export function tempoWords(language: LanguageCode, mode: TempoMode): readonly string[] {
  const { minLength, maxLength } = LENGTHS[mode];
  const words = getWords(language, { minLength, maxLength, limit: POOL_SIZE });

  // Пул не может быть пустым: словарь языка заведомо содержит короткие слова.
  // Если ограничение по длине оказалось слишком узким, оно снимается — лучше
  // слово не той длины, чем занятие без материала.
  return words.length > 0
    ? words.map((word) => word.text)
    : getWords(language, { limit: POOL_SIZE }).map((word) => word.text);
}
